import React, { useState } from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import ActionButton from '../../common/ActionButton';
import { ROOT_URL_V2 } from '../../../config';
import { executeHttpRequest } from '../../../epics/api';
import { getErrorMessages } from '../../../utils';
import { TPageNotification } from '../../../types';


type TModalConfirmDownloadProps = {
    handleClose: () => void;
    isOpen: boolean;
    downloadHistory: {
        id: number;
        created: string;
        agent: string;
        client: string;
    }[],
    downloadPayrollCSV: () => void;
}

function ModalConfirmDownload({
    handleClose,
    isOpen,
    downloadHistory,
    downloadPayrollCSV,
}: TModalConfirmDownloadProps) {

    return (
        <Modal
            className="cancel-worker-modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            contentLabel="Confirm download"
            ariaHideApp={false}
        >
            <p className="modal-title">Confirm download</p>
            <div className="cancel-worker-body">
                <p>Please note: A previous file has already been exported for the same period (and client):</p>
                {downloadHistory.map((entry, i) =>
                    <p key={entry.id} className={i === 0 ? 'margin-top-10' : ''}>
                        {entry.client} - on {moment(entry.created).format('DD/MM/YYYY')} by {entry.agent}
                    </p>
                )}
                <p className="margin-top-10">
                    Please confirm that you wish to proceed with exporting a new file?
                </p>
            </div>

            <button
                className="continue btn--round-big"
                onClick={downloadPayrollCSV}
                type="button"
            >
                DOWNLOAD
            </button>
            <button className="back" onClick={handleClose} type="button">
                CANCEL
            </button>
        </Modal>
    );
}


type TDownloadPayrollCSVProps = {
    history: any;
    endpoint: string;
    notification: TPageNotification;
}

export default function DownloadPayrollCSVButton({
    history,
    endpoint,
    notification,
}: TDownloadPayrollCSVProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [downloadHistory, setDownloadHistory] = useState(null);
    const currentUrlParams = new URLSearchParams(history.location.search);

    const getDownloadUrl = () =>
        `${ROOT_URL_V2}${endpoint}/?${currentUrlParams.toString()}&format=csv`;

    const handleCloseModal = () => setIsModalOpen(false);

    const downloadPayrollCSV = () => {
        window.location.href = getDownloadUrl();
        if (isModalOpen) {
            handleCloseModal();
        }
    };

    const onButtonClick = () => {
        executeHttpRequest(
            `payroll-history/?${currentUrlParams.toString()}`,
            'get'
        ).then(resp => {
            if (!resp.data.content.length) {
                downloadPayrollCSV();
            } else {
                setDownloadHistory(resp.data.content);
                setIsModalOpen(true);
            }
        }).catch(err =>
            notification.error('Error', getErrorMessages(err))
        );
    };

    return (
        <>
            <ActionButton
                iconClass="icon-navigation-next-4"
                tooltip="Export as CSV"
                onAction={onButtonClick}
            />
            {isModalOpen && (
                <ModalConfirmDownload
                    handleClose={handleCloseModal}
                    isOpen={isModalOpen}
                    downloadHistory={downloadHistory}
                    downloadPayrollCSV={downloadPayrollCSV}
                />
            )}
        </>
    );
}
